/**
 * The one place a `SetupRouteName` becomes a navigable href.
 *
 * `resolveSetupRoute` answers in route NAMES so it can stay free of expo-router;
 * this map is the single translation into hrefs, shared by the group layout's
 * guard, the dispatcher, and the username screen.
 */

import type { Href } from 'expo-router';

import type { SetupRouteName } from '@/features/setup/gate/resolve-setup-route';

/**
 * `(setup)` is a route group, so it does not appear in the path -- these are the
 * same paths `SETUP_STEP_ROUTES` in `setup-provider.tsx` pushes.
 */
export const SETUP_ROUTE_HREFS: Record<SetupRouteName, Href> = {
  username: '/username',
  welcome: '/welcome',
  permissions: '/permissions',
  intent: '/intent',
  taste: '/taste',
  friends: '/friends',
  done: '/done',
};
